import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'

import './ApprovePaymentDialog.css'

const ApprovePaymentDialog = () => {
  const { isApprovePaymentPopUpVisible } = useSelector(state => state.payment)
  const dialogActions = []
  const dispatch = useDispatch()
  const payment = useSelector(state => state.payment)
  const last4Digits = payment?.last4

  const plan = payment?.my_subscriptions?.[0]?.plan_details

  const onApprove = () => {
    dispatch(Actions.createAction(Actions.CLOSE_APPROVE_PAYMENT_POP_UP))
    dispatch(Actions.createAction(Actions.PAYMENT_FLOW_COMPLETED))
  }

  const onCancel = () => {
    dispatch(Actions.createAction(Actions.CLOSE_APPROVE_PAYMENT_POP_UP))
    dispatch(Actions.createAction(Actions.PAYMENT_FLOW_CANCELLED))
  }

  const onAddPaymentMethod = copayPk => {
    dispatch(Actions.createAction(Actions.CLOSE_APPROVE_PAYMENT_POP_UP))
    dispatch(Actions.createAction(Actions.PAYMENT_FLOW_COMPLETED))
    dispatch(
      Actions.createAction(Actions.COPAY_PLAN_DETAILS_REQUESTED, {
        copayPk: copayPk,
      })
    )
  }

  return (
    <Dialog
      title={
        last4Digits
          ? $t('pages.getStarted.approvePaymentPopup.titleApproval')
          : $t('pages.getStarted.approvePaymentPopup.titlePayment')
      }
      isVisible={isApprovePaymentPopUpVisible}
      footerActions={dialogActions}
      onCancel={onCancel}
      className="approve-payment-dialogue"
    >
      <div className="approve-payment-dialogue-container">
        <div className="approve-payment-description">
          {$t('pages.getStarted.approvePaymentPopup.paymentOf', {
            price: plan?.copay_visit_price || plan?.visit_price,
          })}
          {last4Digits && <br />}
          {last4Digits
            ? $t('pages.getStarted.approvePaymentPopup.withCard', {
                last4: last4Digits,
              })
            : $t('pages.getStarted.approvePaymentPopup.withNoCard')}
        </div>
        <Button
          className="approve-payment-method-button"
          type="primary"
          onClick={
            last4Digits
              ? onApprove
              : () => onAddPaymentMethod(plan?.copay_plan_id)
          }
        >
          {last4Digits
            ? $t('pages.getStarted.approvePaymentPopup.approve')
            : $t('pages.getStarted.approvePaymentPopup.confirm')}
        </Button>
      </div>
    </Dialog>
  )
}

export default ApprovePaymentDialog
